import {
  SET_ORGANIZATION_AVATAR_SUCCESS,
  SET_ORGANIZATION_WORK_SHEET_NAME_SUCCESS,
  SET_ORGANIZATION_WORK_SHEET_MEANING_SUCCESS,
  SET_ORGANIZATION_WORK_SHEET_LINKS_SUCCESS,
  SET_ORGANIZATION_WORK_SHEET_DRIVERS_SUCCESS,
  SET_ORGANIZATION_WORK_SHEET_TRIGGERS_SUCCESS,
  SET_ORGANIZATION_WORK_SHEET_SUCCESS,
  SET_ORGANIZATION_REQUEST,
  SET_ORGANIZATION_FAILED,
  CLEAN_ORGANIZATION,
} from './types';

const initialState = {
  name: '',
  id: undefined,
  avatars: null,
  meanings: [],
  drivers: [],
  triggers: [],
  links: [],
  loading: false,
  error: null
};

export default function organization(state = initialState, action) {
  switch (action.type) {
    case SET_ORGANIZATION_AVATAR_SUCCESS:
      return {
        ...state,
        avatars: action.data,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_WORK_SHEET_NAME_SUCCESS:
      return {
        ...state,
        name: action.data,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_WORK_SHEET_MEANING_SUCCESS:
      return {
        ...state,
        meanings: action.data,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_WORK_SHEET_LINKS_SUCCESS:
      return {
        ...state,
        links: action.data,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_WORK_SHEET_DRIVERS_SUCCESS:
      return {
        ...state,
        drivers: action.data,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_WORK_SHEET_TRIGGERS_SUCCESS:
      return {
        ...state,
        triggers: action.data,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_WORK_SHEET_SUCCESS:
      return {
        ...state,
        id: action.data.id,
        name: action.data.full_name,
        avatars: action.data.avatars,
        segment: action.data.segment_id,
        meanings: action.data.meanings,
        drivers: action.data.drivers,
        triggers: action.data.triggers,
        links: action.data.links,
        loading: false,
        error: null
      };
    case SET_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true
      };
    case SET_ORGANIZATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case CLEAN_ORGANIZATION:
      return initialState;
    default:
      return state;
  }
}
